/** Modelli Bedrock che rifiutano `temperature` in Converse (allineato a ocean-agent-runner.mjs). */
export function bedrockOmitsTemperature(modelId: string): boolean {
  const id = modelId.trim().toLowerCase();
  if (!id) return false;
  if (id.includes("inference-profile")) return true;
  if (id.includes("amazon.nova-premier")) return true;
  // Claude 4.x recenti (incl. us.anthropic.claude-opus-4-8)
  if (/anthropic\.claude-(opus|sonnet|haiku)-4-/.test(id)) return true;
  if (/anthropic\.claude-opus-4-[6-9]/.test(id)) return true;
  return false;
}

export function buildAgentInferenceConfigJson(modelId: string): string {
  const maxTokens = 4096;
  if (bedrockOmitsTemperature(modelId)) {
    return JSON.stringify({ maxTokens, omitTemperature: true });
  }
  return JSON.stringify({ maxTokens, temperature: 0.3 });
}
